import AdminLotesDetail from "./AdminLotesDetail";
import container from "./container";

export default container(AdminLotesDetail);
